import { action } from 'mobx';
import { SessionStore } from './session.store';
import { AggregateFunction, AgtAnalyticsStore, SelectColumn } from './agt.analytics.store';

export interface IAgtAkumaPrimeModel {
	vtnrId: number;
	kw: number;
	einordnungTotal: number;
	eingeordnetTotal: number;
	einordnungsquote: number;
	einordnungSach: number;
	einordnungLeben: number;
	einordnungKranken: number;
	einordnungSonstige: number;
	einordnungFonds: number;
	einordnungNichtKontaktieren: number;
	einordnungBestehendeAktion: number;
	einordnungNichtEingeordnet: number;
	abwahl: number;
	abwahlquote: number;
	zuKontaktierendeKunden: number;
	terminierungAgentur: number;
	terminierungExternTotal: number;
	terminierungExternQuote: number;
	beziehungUnbekannt: number;
	beziehungWenigerGut: number;
	beziehungMittel: number;
	beziehungGut: number;
}

export class AgtAkumaPrimeModel implements IAgtAkumaPrimeModel {
	vtnrId: number;
	kw: number;
	einordnungTotal: number;
	eingeordnetTotal: number;
	einordnungsquote: number;
	einordnungSach: number;
	einordnungLeben: number;
	einordnungKranken: number;
	einordnungSonstige: number;
	einordnungFonds: number;
	einordnungNichtKontaktieren: number;
	einordnungBestehendeAktion: number;
	einordnungNichtEingeordnet: number;
	abwahl: number;
	abwahlquote: number;
	zuKontaktierendeKunden: number;
	terminierungAgentur: number;
	terminierungExternTotal: number;
	terminierungExternQuote: number;
	beziehungUnbekannt: number;
	beziehungWenigerGut: number;
	beziehungMittel: number;
	beziehungGut: number;
	maxKw: number;
	kundenkontaktquote: number;

	// Legacy compatibility properties
	agtId: number;
	bm: number;

	constructor(data: any) {
		this.vtnrId = data.vtnr_id || 0;
		this.kw = data.kw || 0;
		this.einordnungTotal = data.einordnung_total || 0;
		this.eingeordnetTotal = data.eingeordnet_total || 0;
		this.einordnungsquote = data.einordnungsquote || 0;
		this.einordnungSach = data.einordnung_sach || 0;
		this.einordnungLeben = data.einordnung_leben || 0;
		this.einordnungKranken = data.einordnung_kranken || 0;
		this.einordnungSonstige = data.einordnung_sonstige || 0;
		this.einordnungFonds = data.einordnung_fonds || 0;
		this.einordnungNichtKontaktieren = data.einordnung_nicht_kontaktieren || 0;
		this.einordnungBestehendeAktion = data.einordnung_bestehende_aktion || 0;
		this.einordnungNichtEingeordnet = data.einordnung_nicht_eingeordnet || 0;
		this.abwahl = data.abwahl || 0;
		this.abwahlquote = data.abwahlquote || 0;
		this.zuKontaktierendeKunden = data.zu_kontaktierende_kunden || 0;
		this.terminierungAgentur = data.terminierung_agentur || 0;
		this.terminierungExternTotal = data.terminierung_extern_total || 0;
		this.terminierungExternQuote = data.terminierung_extern_quote || 0;
		this.beziehungUnbekannt = data.beziehung_unbekannt || 0;
		this.beziehungWenigerGut = data.beziehung_weniger_gut || 0;
		this.beziehungMittel = data.beziehung_mittel || 0;
		this.beziehungGut = data.beziehung_gut || 0;
		this.maxKw = data.maxkw || 0;
		this.kundenkontaktquote = data.kundenkontaktquote || 0;

		// Legacy compatibility - alias properties
		this.agtId = this.vtnrId;
		this.bm = this.kw;
	}
}

export class AgtAkumaPrimeStore extends AgtAnalyticsStore {
	constructor(session: SessionStore) {
		super(session, {
			tableName: 'agentur_akumaprime',
			defaultColumns: [
				{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE },
				{ column: 'kw', aggregateFunction: AggregateFunction.NONE },
				{ column: 'einordnung_total', aggregateFunction: AggregateFunction.SUM },
				{ column: 'eingeordnet_total', aggregateFunction: AggregateFunction.SUM },
				{ column: 'einordnungsquote', aggregateFunction: AggregateFunction.AVG },
				{ column: 'einordnung_sach', aggregateFunction: AggregateFunction.SUM },
				{ column: 'einordnung_leben', aggregateFunction: AggregateFunction.SUM },
				{ column: 'einordnung_kranken', aggregateFunction: AggregateFunction.SUM },
				{ column: 'einordnung_sonstige', aggregateFunction: AggregateFunction.SUM },
				{ column: 'einordnung_fonds', aggregateFunction: AggregateFunction.SUM },
				{ column: 'einordnung_nicht_kontaktieren', aggregateFunction: AggregateFunction.SUM },
				{ column: 'einordnung_bestehende_aktion', aggregateFunction: AggregateFunction.SUM },
				{ column: 'einordnung_nicht_eingeordnet', aggregateFunction: AggregateFunction.SUM },
				{ column: 'abwahl', aggregateFunction: AggregateFunction.SUM },
				{ column: 'abwahlquote', aggregateFunction: AggregateFunction.AVG },
				{ column: 'zu_kontaktierende_kunden', aggregateFunction: AggregateFunction.SUM },
				{ column: 'terminierung_agentur', aggregateFunction: AggregateFunction.SUM },
				{ column: 'terminierung_extern_total', aggregateFunction: AggregateFunction.SUM },
				{ column: 'terminierung_extern_quote', aggregateFunction: AggregateFunction.AVG },
				{ column: 'beziehung_unbekannt', aggregateFunction: AggregateFunction.SUM },
				{ column: 'beziehung_weniger_gut', aggregateFunction: AggregateFunction.SUM },
				{ column: 'beziehung_mittel', aggregateFunction: AggregateFunction.SUM },
				{ column: 'beziehung_gut', aggregateFunction: AggregateFunction.SUM },
				{ column: 'kundenkontaktquote', aggregateFunction: AggregateFunction.AVG, alias: 'kundenkontaktquote' },
			],
		});
		this.queryName = '?akumaPrime';
	}

	async getDistinctKWs(): Promise<number[]> {
		const selectColumns: SelectColumn[] = [
			{ column: 'kw', aggregateFunction: AggregateFunction.NONE, distinct: true },
		];
		const results = await this.query(selectColumns);
		return results.map(data => data.kw).sort((a, b) => a - b);
	}

	@action
	async aggregateAgtByKw(agtId: number, minKw?: number, maxKw?: number): Promise<AgtAkumaPrimeModel[]> {
		let whereClause = 'a.vtnr_id = ' + agtId + ' and ';
		if (minKw && maxKw) {
			whereClause += `kw BETWEEN ${minKw} AND ${maxKw}`;
		} else if (minKw) {
			whereClause += `kw >= ${minKw}`;
		} else if (maxKw) {
			whereClause += `kw <= ${maxKw}`;
		}

		const selectColumns: SelectColumn[] = [
			{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE, groupBy: true },
			{ column: 'kw', aggregateFunction: AggregateFunction.NONE, groupBy: true },
			{ column: 'einordnung_total', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_total' },
			{ column: 'eingeordnet_total', aggregateFunction: AggregateFunction.SUM, alias: 'eingeordnet_total' },
			{ column: 'einordnung_sach', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_sach' },
			{ column: 'einordnung_leben', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_leben' },
			{ column: 'einordnung_kranken', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_kranken' },
			{ column: 'einordnung_sonstige', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_sonstige' },
			{ column: 'einordnung_fonds', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_fonds' },
			{ column: 'einordnung_nicht_kontaktieren', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_nicht_kontaktieren' },
			{ column: 'einordnung_bestehende_aktion', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_bestehende_aktion' },
			{ column: 'einordnung_nicht_eingeordnet', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_nicht_eingeordnet' },
			{ column: 'abwahl', aggregateFunction: AggregateFunction.SUM, alias: 'abwahl' },
			{ column: 'zu_kontaktierende_kunden', aggregateFunction: AggregateFunction.SUM, alias: 'zu_kontaktierende_kunden' },
			{ column: 'terminierung_agentur', aggregateFunction: AggregateFunction.SUM, alias: 'terminierung_agentur' },
			{ column: 'terminierung_extern_total', aggregateFunction: AggregateFunction.SUM, alias: 'terminierung_extern_total' },
			{ column: 'beziehung_unbekannt', aggregateFunction: AggregateFunction.SUM, alias: 'beziehung_unbekannt' },
			{ column: 'beziehung_weniger_gut', aggregateFunction: AggregateFunction.SUM, alias: 'beziehung_weniger_gut' },
			{ column: 'beziehung_mittel', aggregateFunction: AggregateFunction.SUM, alias: 'beziehung_mittel' },
			{ column: 'beziehung_gut', aggregateFunction: AggregateFunction.SUM, alias: 'beziehung_gut' },
			{ column: 'kundenkontaktquote', aggregateFunction: AggregateFunction.AVG, alias: 'kundenkontaktquote' },

			{ column: 'kw', aggregateFunction: AggregateFunction.MAX, alias: 'maxkw' },
		];

		const results = await this.query(selectColumns, whereClause);
		// Calculate derived fields
		const models = results.map(data => {
			// Calculate quotes based on aggregated sums
			if (data.einordnung_total > 0) {
				data.einordnungsquote = (data.eingeordnet_total / data.einordnung_total) * 100;
			} else {
				data.einordnungsquote = 0;
			}

			if (data.eingeordnet_total > 0) {
				data.abwahlquote = (data.abwahl / data.eingeordnet_total) * 100;
			} else {
				data.abwahlquote = 0;
			}

			if (data.zu_kontaktierende_kunden > 0) {
				data.terminierung_extern_quote = (data.terminierung_extern_total / data.zu_kontaktierende_kunden) * 100;
			} else {
				data.terminierung_extern_quote = 0;
			}

			return new AgtAkumaPrimeModel(data);
		});
		return models;
	}


	@action
	async aggregateByAgt(minKw?: number, maxKw?: number): Promise<AgtAkumaPrimeModel[]> {
		let whereClause = '';
		if (minKw && maxKw) {
			whereClause = `kw BETWEEN ${minKw} AND ${maxKw}`;
		} else if (minKw) {
			whereClause = `kw >= ${minKw}`;
		} else if (maxKw) {
			whereClause = `kw <= ${maxKw}`;
		}

		const selectColumns: SelectColumn[] = [
			{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE, groupBy: true },
			{ column: 'einordnung_total', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_total' },
			{ column: 'eingeordnet_total', aggregateFunction: AggregateFunction.SUM, alias: 'eingeordnet_total' },
			{ column: 'einordnung_sach', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_sach' },
			{ column: 'einordnung_leben', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_leben' },
			{ column: 'einordnung_kranken', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_kranken' },
			{ column: 'einordnung_sonstige', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_sonstige' },
			{ column: 'einordnung_fonds', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_fonds' },
			{ column: 'einordnung_nicht_kontaktieren', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_nicht_kontaktieren' },
			{ column: 'einordnung_bestehende_aktion', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_bestehende_aktion' },
			{ column: 'einordnung_nicht_eingeordnet', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_nicht_eingeordnet' },
			{ column: 'abwahl', aggregateFunction: AggregateFunction.SUM, alias: 'abwahl' },
			{ column: 'zu_kontaktierende_kunden', aggregateFunction: AggregateFunction.SUM, alias: 'zu_kontaktierende_kunden' },
			{ column: 'terminierung_agentur', aggregateFunction: AggregateFunction.SUM, alias: 'terminierung_agentur' },
			{ column: 'terminierung_extern_total', aggregateFunction: AggregateFunction.SUM, alias: 'terminierung_extern_total' },
			{ column: 'beziehung_unbekannt', aggregateFunction: AggregateFunction.SUM, alias: 'beziehung_unbekannt' },
			{ column: 'beziehung_weniger_gut', aggregateFunction: AggregateFunction.SUM, alias: 'beziehung_weniger_gut' },
			{ column: 'beziehung_mittel', aggregateFunction: AggregateFunction.SUM, alias: 'beziehung_mittel' },
			{ column: 'beziehung_gut', aggregateFunction: AggregateFunction.SUM, alias: 'beziehung_gut' },
			{ column: 'kundenkontaktquote', aggregateFunction: AggregateFunction.AVG, alias: 'kundenkontaktquote' },

			{ column: 'kw', aggregateFunction: AggregateFunction.MAX, alias: 'maxkw' },
		];

		const results = await this.query(selectColumns, whereClause);
		// Calculate derived fields
		const models = results.map(data => {
			// Calculate quotes based on aggregated sums
			if (data.einordnung_total > 0) {
				data.einordnungsquote = (data.eingeordnet_total / data.einordnung_total) * 100;
			} else {
				data.einordnungsquote = 0;
			}

			if (data.eingeordnet_total > 0) {
				data.abwahlquote = (data.abwahl / data.eingeordnet_total) * 100;
			} else {
				data.abwahlquote = 0;
			}

			if (data.zu_kontaktierende_kunden > 0) {
				data.terminierung_extern_quote = (data.terminierung_extern_total / data.zu_kontaktierende_kunden) * 100;
			} else {
				data.terminierung_extern_quote = 0;
			}

			return new AgtAkumaPrimeModel(data);
		});
		return models;
	}

	@action
	async aggregateByKw(minKw?: number, maxKw?: number): Promise<AgtAkumaPrimeModel[]> {
		let whereClause = '';
		if (minKw && maxKw) {
			whereClause = `kw BETWEEN ${minKw} AND ${maxKw}`;
		} else if (minKw) {
			whereClause = `kw >= ${minKw}`;
		} else if (maxKw) {
			whereClause = `kw <= ${maxKw}`;
		}

		const selectColumns: SelectColumn[] = [
			{ column: 'kw', aggregateFunction: AggregateFunction.NONE, groupBy: true },
			{ column: 'vtnr_id', aggregateFunction: AggregateFunction.NONE, groupBy: true },
			{ column: 'einordnung_total', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_total' },
			{ column: 'eingeordnet_total', aggregateFunction: AggregateFunction.SUM, alias: 'eingeordnet_total' },
			{ column: 'einordnung_sach', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_sach' },
			{ column: 'einordnung_leben', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_leben' },
			{ column: 'einordnung_kranken', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_kranken' },
			{ column: 'einordnung_sonstige', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_sonstige' },
			{ column: 'einordnung_fonds', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_fonds' },
			{ column: 'einordnung_nicht_kontaktieren', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_nicht_kontaktieren' },
			{ column: 'einordnung_bestehende_aktion', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_bestehende_aktion' },
			{ column: 'einordnung_nicht_eingeordnet', aggregateFunction: AggregateFunction.SUM, alias: 'einordnung_nicht_eingeordnet' },
			{ column: 'abwahl', aggregateFunction: AggregateFunction.SUM, alias: 'abwahl' },
			{ column: 'zu_kontaktierende_kunden', aggregateFunction: AggregateFunction.SUM, alias: 'zu_kontaktierende_kunden' },
			{ column: 'terminierung_agentur', aggregateFunction: AggregateFunction.SUM, alias: 'terminierung_agentur' },
			{ column: 'terminierung_extern_total', aggregateFunction: AggregateFunction.SUM, alias: 'terminierung_extern_total' },
			{ column: 'beziehung_unbekannt', aggregateFunction: AggregateFunction.SUM, alias: 'beziehung_unbekannt' },
			{ column: 'beziehung_weniger_gut', aggregateFunction: AggregateFunction.SUM, alias: 'beziehung_weniger_gut' },
			{ column: 'beziehung_mittel', aggregateFunction: AggregateFunction.SUM, alias: 'beziehung_mittel' },
			{ column: 'beziehung_gut', aggregateFunction: AggregateFunction.SUM, alias: 'beziehung_gut' },
			{ column: 'kundenkontaktquote', aggregateFunction: AggregateFunction.AVG, alias: 'kundenkontaktquote' },
		];

		const results = await this.query(selectColumns, whereClause);
		// Calculate derived fields
		const models = results.map(data => {
			// Calculate quotes based on aggregated sums
			if (data.einordnung_total > 0) {
				data.einordnungsquote = (data.eingeordnet_total / data.einordnung_total) * 100;
			} else {
				data.einordnungsquote = 0;
			}

			if (data.eingeordnet_total > 0) {
				data.abwahlquote = (data.abwahl / data.eingeordnet_total) * 100;
			} else {
				data.abwahlquote = 0;
			}

			if (data.zu_kontaktierende_kunden > 0) {
				data.terminierung_extern_quote = (data.terminierung_extern_total / data.zu_kontaktierende_kunden) * 100;
			} else {
				data.terminierung_extern_quote = 0;
			}

			return new AgtAkumaPrimeModel(data);
		});
		return models;
	}
}